import { render } from "./Enlargement.vue?vue&type=template&id=508d4cee&ts=true"
import script from "./Enlargement.vue?vue&type=script&lang=ts"
export * from "./Enlargement.vue?vue&type=script&lang=ts"

import "./Enlargement.vue?vue&type=style&index=0&id=508d4cee&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__